import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a /api/activity/track POST on every route change for authenticated sessions.
 * Backend silently ignores unauthenticated calls (401), so this is safe pre-login too.
 */
export function ActivityTracker() {
  const location = useLocation();
  const lastPath = useRef<string>("");

  useEffect(() => {
    const path = location.pathname;
    if (!path || path === lastPath.current) return;
    lastPath.current = path;

    // Skip public routes that don't reflect engagement
    const skip = ["/auth", "/paiement/callback"];
    if (skip.some((p) => path.startsWith(p))) return;

    const url = `${process.env.REACT_APP_BACKEND_URL || ""}/api/activity/track`;
    // Best-effort fire-and-forget; never block navigation
    fetch(url, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ module: path, action: "pageview" }),
    }).catch(() => {});
  }, [location.pathname]);

  return null;
}
